import axios from 'axios';
import { EXTERNAL_DB_USER } from '../../types';
import { USER_LOGIN } from '../../API';

export async function getUserInfo(email, dispatch) {
  try {
    const response = await axios.get(USER_LOGIN, {
      params: {
        email,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.status === 200) {
      const userInfo = response.data;
      dispatch({
        type: EXTERNAL_DB_USER,
        payload: userInfo.user,
      });
      return { success: true, userInfo: userInfo.user };
    }

    return { success: false, userInfo: null };
  } catch (error) {
    // console.log('error getting user info', error);
    return { success: false, message: error.response.data.message };
  }
}
